import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/index/new-clue.svg'
import _imports_1 from '@/assets/index/new-business.svg'
import _imports_2 from '@/assets/index/new-visitor.svg'
import _imports_3 from '@/assets/index/new-follow.svg'
import _imports_4 from '@/assets/index/key-new-clue.svg'
import _imports_5 from '@/assets/index/key-new-business.svg'
import _imports_6 from '@/assets/index/key-new-visitor.svg'
import _imports_7 from '@/assets/index/key-new-follow.svg'
import _imports_8 from '@/assets/index/key-new-money.svg'


const _withScopeId = n => (_pushScopeId("data-v-014c68f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "index-box" }
const _hoisted_2 = { class: "top-tab-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-tab-msg" }, [
  /*#__PURE__*/_createElementVNode("p", null, "新建线索"),
  /*#__PURE__*/_createElementVNode("span", null, "LEADS")
], -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-tab-msg" }, [
  /*#__PURE__*/_createElementVNode("p", null, "新建商机"),
  /*#__PURE__*/_createElementVNode("span", null, "OPPORTUNITIES")
], -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-tab-msg" }, [
  /*#__PURE__*/_createElementVNode("p", null, "新建访客计划"),
  /*#__PURE__*/_createElementVNode("span", null, "VISITORS PROGRAM")
], -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-tab-msg" }, [
  /*#__PURE__*/_createElementVNode("p", null, "写新跟进"),
  /*#__PURE__*/_createElementVNode("span", null, "FOLLOW-UP")
], -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "key-data-box" }
const _hoisted_16 = { class: "top-label-from-box" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "关键数据指标", -1))
const _hoisted_18 = { class: "from-box" }
const _hoisted_19 = { class: "key-data" }
const _hoisted_20 = { class: "data-box" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_22 = { class: "data-msg" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "新增线索数", -1))
const _hoisted_24 = { style: {"color":"#877ced"} }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "个", -1))
const _hoisted_26 = { class: "data-box" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
}, null, -1))
const _hoisted_28 = { class: "data-msg" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "新增商机数", -1))
const _hoisted_30 = { style: {"color":"#36c8e1"} }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "个", -1))
const _hoisted_32 = { class: "data-box" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: ""
}, null, -1))
const _hoisted_34 = { class: "data-msg" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "新增访客计划数", -1))
const _hoisted_36 = { style: {"color":"#4ec690"} }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "个", -1))
const _hoisted_38 = { class: "data-box" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: ""
}, null, -1))
const _hoisted_40 = { class: "data-msg" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "新增跟进记录数", -1))
const _hoisted_42 = { style: {"color":"#ffb648"} }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "个", -1))
const _hoisted_44 = { class: "data-box" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  alt: ""
}, null, -1))
const _hoisted_46 = { class: "data-msg" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "新增商机金额数", -1))
const _hoisted_48 = { style: {"color":"#3f97ff"} }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "元", -1))
const _hoisted_50 = { class: "out-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GlobalSearch = _resolveComponent("GlobalSearch")!
  const _component_cos_range_picker = _resolveComponent("cos-range-picker")!
  const _component_HomeBusinessAmountBarChart = _resolveComponent("HomeBusinessAmountBarChart")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_HomeLeadOrUserBarChar = _resolveComponent("HomeLeadOrUserBarChar")!
  const _component_HomeOpportunityFunnel = _resolveComponent("HomeOpportunityFunnel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_GlobalSearch, { type: 'cos_lbu' }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "top-tab new-clue",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleRouterGo('/lbu/salesClue/add')))
      }, _hoisted_5),
      _createElementVNode("div", {
        class: "top-tab new-business",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleRouterGo('/lbu/business/add')))
      }, _hoisted_8),
      _createElementVNode("div", {
        class: "top-tab new-visitor",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleRouterGo('/lbu/visitorProgram/add')))
      }, _hoisted_11),
      _createElementVNode("div", {
        class: "top-tab new-follow",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleRouterGo('/lbu/followUpRecord/add')))
      }, _hoisted_14)
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_cos_range_picker, {
            startTime: _ctx.formState.keyData.startTime,
            "onUpdate:startTime": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formState.keyData.startTime) = $event)),
            endTime: _ctx.formState.keyData.endTime,
            "onUpdate:endTime": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formState.keyData.endTime) = $event)),
            allowClear: false
          }, null, 8, ["startTime", "endTime"])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("span", _hoisted_24, [
              _createTextVNode(_toDisplayString(_ctx.keyBackData.clueCount || 0), 1),
              _hoisted_25
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("span", _hoisted_30, [
              _createTextVNode(_toDisplayString(_ctx.keyBackData.chanceCount || 0), 1),
              _hoisted_31
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _hoisted_33,
          _createElementVNode("div", _hoisted_34, [
            _hoisted_35,
            _createElementVNode("span", _hoisted_36, [
              _createTextVNode(_toDisplayString(_ctx.keyBackData.visitCount || 0), 1),
              _hoisted_37
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_38, [
          _hoisted_39,
          _createElementVNode("div", _hoisted_40, [
            _hoisted_41,
            _createElementVNode("span", _hoisted_42, [
              _createTextVNode(_toDisplayString(_ctx.keyBackData.followCount || 0), 1),
              _hoisted_43
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_44, [
          _hoisted_45,
          _createElementVNode("div", _hoisted_46, [
            _hoisted_47,
            _createElementVNode("span", _hoisted_48, [
              _createTextVNode(_toDisplayString(_ctx.keyBackData.planSaleAmount || 0), 1),
              _hoisted_49
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_a_row, { gutter: 16 }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_HomeBusinessAmountBarChart, { appId: "cos_lbu" })
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 12 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_50, [
              _createVNode(_component_Calendar, { appId: 'lbu' })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, { gutter: 16 }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_HomeLeadOrUserBarChar, {
              appId: "cos_lbu",
              type: "user"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_HomeOpportunityFunnel, { appId: "cos_lbu" })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_HomeLeadOrUserBarChar, {
              appId: "cos_lbu",
              type: "lead"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}